<template>
  <div>
    <div class="tabs-container">
      <router-link
        class="tab"
        :class="{ active: $route.path.includes('estoque') }"
        :to="`/estoque/saldo`"
      >
        Estoque
      </router-link>

      <!-- Ocultar todas as outras abas se relacionamento for vazio -->
      <!-- <template v-if="`${$route.params.id} == 0`"> -->
      <router-link
        class="tab"
        :class="{ active: $route.path.includes('movimentacoes') }"
        :to="`/estoque/movimentacoes`"
      >
        Movimentações
      </router-link>

      <router-link
        class="tab"
        :class="{ active: $route.path.includes('itens') }"
        :to="`/estoque/itens`"
      >
        Itens
      </router-link>

      <router-link
        class="tab"
        :class="{ active: $route.path.includes('categorias') }"
        :to="`/estoque/categorias`"
      >
        Categorias
      </router-link>

      <router-link
        class="tab"
        :class="{ active: $route.path.includes('locais') }"
        :to="`/estoque/locais`"
      >
        Locais
      </router-link>
      <!-- </template> -->
    </div>

    <div class="tab-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { ref, watch } from 'vue';

const route = useRoute();
const abaAtual = ref(route.path);
watch(route, novaRota => {
  abaAtual.value = novaRota.path;
});
</script>
<style scoped>
/* Insira o CSS fornecido aqui */
.tabs-container {
  display: flex;
  border-bottom: 2px solid #ddd;
  margin-bottom: 10px;
}

.tab {
  text-decoration: none; /* Remove sublinhado */
  display: inline-block; /* Garante que a borda inferior funcione corretamente */
  padding: 10px 20px;
  cursor: pointer;
  font-weight: bold;
  color: #555;
  transition: color 0.3s, border-bottom 0.3s;
  border-bottom: 2px solid transparent;
}

.tab:hover {
  color: #ff562b;
}

.tab.active {
  color: #ff562b;
  border-bottom: 2px solid #ff562b;
}

.tab-content {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 5px;
}
</style>
